import * as React from "react";
import { Icon } from "../Icon/icon";

interface PrintButtonProps {
  buttonText?: string;
  classNames?: string;
  iconType?: string;
}

/**
 * Renders a print icon which triggers print functionality of the web browser.
 */
export class PrintButton extends React.Component<PrintButtonProps> {
  static defaultProps = {
    buttonText: "Skriv ut",
  };

  print = (e: React.MouseEvent) => {
    e.preventDefault();
    if (window) {
      window.print();
    }
  };

  render() {
    return (
      <button
        onClick={this.print}
        className={this.props.classNames ?? "print-button"}
      >
        <Icon iconType={this.props.iconType ?? "Print"} />{" "}
        {this.props.buttonText}
      </button>
    );
  }
}
